import React from "react";
import { css } from "emotion";
import SettingsLink from "../SettingsLink";
import GenericCard from "../../GenericCard";
import TitleWithBackButton from "../../TitleWithBackButton";

const WorkspaceDesktop = () => {
  return (
    <div className={container}>
      <TitleWithBackButton title="Manage Workspace" backLocation="settings" />
      <GenericCard style="main-card">
        <SettingsLink route="billing" />
        <SettingsLink route="users" />
      </GenericCard>
    </div>
  );
};

export default WorkspaceDesktop;

const container = css`
  width: 80%;
  padding-top: 30px;
  margin: auto;
  .main-card {
    flex-direction: column;
    width: 100%;
  }
`;
